// Mock data for Erste Hilfe Bottrop website

export const courses = [
  {
    id: 'erste-hilfe-kurs',
    title: 'Erste Hilfe Kurs (9 UE)',
    shortDescription: 'Pflichtkurs für alle Führerscheinklassen, Studium, Ausbildung und Beruf.',
    description: 'Der anerkannte Erste-Hilfe-Kurs für Führerschein, Studium und Beruf. Praxisnah, leicht verständlich und an einem Tag abgeschlossen.',
    highlights: [
      'Anerkannt nach Fahrerlaubnis-Verordnung (FeV)',
      'Gültig für alle Führerscheinklassen',
      'Teilnahmebescheinigung direkt nach Kursende',
      'Ideal für Fahrschüler & Privatpersonen'
    ],
    buttonText: 'Termin auswählen',
    icon: 'Heart',
    price: '40,00 €'
  },
  {
    id: 'betriebliche-erste-hilfe',
    title: 'Betriebliche Erste Hilfe',
    shortDescription: 'Gesetzlich vorgeschriebene Schulungen für Unternehmen und Betriebe – auch vor Ort möglich.',
    description: 'Gesetzlich vorgeschriebene Schulung für Ersthelfer im Betrieb. Wir schulen praxisnah – auf Wunsch auch direkt in Ihrem Unternehmen.',
    highlights: [
      'Schulung gemäß DGUV-Vorgaben',
      'Abrechnung über Berufsgenossenschaft möglich',
      'Für kleine, mittlere und große Betriebe'
    ],
    buttonText: 'Anfrage senden',
    icon: 'Building2',
    price: 'Auf Anfrage'
  },
  {
    id: 'brandschutz-sanitaetsdienst',
    title: 'Brandschutz & Sanitätsdienst',
    shortDescription: 'Ausbildung zum Brandschutzhelfer sowie Sanitätsdienst für Veranstaltungen und Betriebe.',
    description: 'Ausbildung zum Brandschutzhelfer sowie professioneller Sanitätsdienst für Veranstaltungen, Baustellen und Events.',
    highlights: [
      'Brandschutzhelfer-Ausbildung nach ASR A2.2',
      'Sanitätsdienst für Events & Veranstaltungen',
      'Professionelles Equipment'
    ],
    buttonText: 'Mehr erfahren',
    icon: 'Flame',
    price: 'Auf Anfrage'
  }
];

// Extended dates for multiple months (Saturday & Sunday only)
export const upcomingDates = [
  // Januar 2025
  {
    id: 101,
    date: '2025-01-11',
    displayDate: 'Samstag, 11. Januar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 8,
    location: 'Bottrop Zentrum',
    month: 'Januar 2025'
  },
  {
    id: 102,
    date: '2025-01-12',
    displayDate: 'Sonntag, 12. Januar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 10,
    location: 'Bottrop Zentrum',
    month: 'Januar 2025'
  },
  {
    id: 103,
    date: '2025-01-18',
    displayDate: 'Samstag, 18. Januar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 12,
    location: 'Bottrop Zentrum',
    month: 'Januar 2025'
  },
  {
    id: 104,
    date: '2025-01-19',
    displayDate: 'Sonntag, 19. Januar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Januar 2025'
  },
  {
    id: 105,
    date: '2025-01-25',
    displayDate: 'Samstag, 25. Januar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 14,
    location: 'Bottrop Zentrum',
    month: 'Januar 2025'
  },
  {
    id: 106,
    date: '2025-01-26',
    displayDate: 'Sonntag, 26. Januar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Januar 2025'
  },
  // Februar 2025
  {
    id: 201,
    date: '2025-02-01',
    displayDate: 'Samstag, 01. Februar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Februar 2025'
  },
  {
    id: 202,
    date: '2025-02-02',
    displayDate: 'Sonntag, 02. Februar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Februar 2025'
  },
  {
    id: 203,
    date: '2025-02-08',
    displayDate: 'Samstag, 08. Februar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 12,
    location: 'Bottrop Zentrum',
    month: 'Februar 2025'
  },
  {
    id: 204,
    date: '2025-02-09',
    displayDate: 'Sonntag, 09. Februar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 14,
    location: 'Bottrop Zentrum',
    month: 'Februar 2025'
  },
  {
    id: 205,
    date: '2025-02-15',
    displayDate: 'Samstag, 15. Februar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Februar 2025'
  },
  {
    id: 206,
    date: '2025-02-16',
    displayDate: 'Sonntag, 16. Februar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Februar 2025'
  },
  {
    id: 207,
    date: '2025-02-22',
    displayDate: 'Samstag, 22. Februar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 10,
    location: 'Bottrop Zentrum',
    month: 'Februar 2025'
  },
  {
    id: 208,
    date: '2025-02-23',
    displayDate: 'Sonntag, 23. Februar 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 13,
    location: 'Bottrop Zentrum',
    month: 'Februar 2025'
  },
  // März 2025
  {
    id: 301,
    date: '2025-03-01',
    displayDate: 'Samstag, 01. März 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'März 2025'
  },
  {
    id: 302,
    date: '2025-03-02',
    displayDate: 'Sonntag, 02. März 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'März 2025'
  },
  {
    id: 303,
    date: '2025-03-08',
    displayDate: 'Samstag, 08. März 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 11,
    location: 'Bottrop Zentrum',
    month: 'März 2025'
  },
  {
    id: 304,
    date: '2025-03-09',
    displayDate: 'Sonntag, 09. März 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 14,
    location: 'Bottrop Zentrum',
    month: 'März 2025'
  },
  {
    id: 305,
    date: '2025-03-15',
    displayDate: 'Samstag, 15. März 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'März 2025'
  },
  {
    id: 306,
    date: '2025-03-16',
    displayDate: 'Sonntag, 16. März 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'März 2025'
  },
  {
    id: 307,
    date: '2025-03-22',
    displayDate: 'Samstag, 22. März 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 9,
    location: 'Bottrop Zentrum',
    month: 'März 2025'
  },
  {
    id: 308,
    date: '2025-03-23',
    displayDate: 'Sonntag, 23. März 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 12,
    location: 'Bottrop Zentrum',
    month: 'März 2025'
  },
  {
    id: 309,
    date: '2025-03-29',
    displayDate: 'Samstag, 29. März 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'März 2025'
  },
  {
    id: 310,
    date: '2025-03-30',
    displayDate: 'Sonntag, 30. März 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'März 2025'
  },
  // April 2025
  {
    id: 401,
    date: '2025-04-05',
    displayDate: 'Samstag, 05. April 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'April 2025'
  },
  {
    id: 402,
    date: '2025-04-06',
    displayDate: 'Sonntag, 06. April 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'April 2025'
  },
  {
    id: 403,
    date: '2025-04-12',
    displayDate: 'Samstag, 12. April 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 10,
    location: 'Bottrop Zentrum',
    month: 'April 2025'
  },
  {
    id: 404,
    date: '2025-04-13',
    displayDate: 'Sonntag, 13. April 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 13,
    location: 'Bottrop Zentrum',
    month: 'April 2025'
  },
  {
    id: 405,
    date: '2025-04-19',
    displayDate: 'Samstag, 19. April 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'April 2025'
  },
  {
    id: 406,
    date: '2025-04-20',
    displayDate: 'Sonntag, 20. April 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'April 2025'
  },
  {
    id: 407,
    date: '2025-04-26',
    displayDate: 'Samstag, 26. April 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 8,
    location: 'Bottrop Zentrum',
    month: 'April 2025'
  },
  {
    id: 408,
    date: '2025-04-27',
    displayDate: 'Sonntag, 27. April 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 11,
    location: 'Bottrop Zentrum',
    month: 'April 2025'
  },
  // Mai 2025
  {
    id: 501,
    date: '2025-05-03',
    displayDate: 'Samstag, 03. Mai 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Mai 2025'
  },
  {
    id: 502,
    date: '2025-05-04',
    displayDate: 'Sonntag, 04. Mai 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Mai 2025'
  },
  {
    id: 503,
    date: '2025-05-10',
    displayDate: 'Samstag, 10. Mai 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 12,
    location: 'Bottrop Zentrum',
    month: 'Mai 2025'
  },
  {
    id: 504,
    date: '2025-05-11',
    displayDate: 'Sonntag, 11. Mai 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 14,
    location: 'Bottrop Zentrum',
    month: 'Mai 2025'
  },
  {
    id: 505,
    date: '2025-05-17',
    displayDate: 'Samstag, 17. Mai 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Mai 2025'
  },
  {
    id: 506,
    date: '2025-05-18',
    displayDate: 'Sonntag, 18. Mai 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Mai 2025'
  },
  {
    id: 507,
    date: '2025-05-24',
    displayDate: 'Samstag, 24. Mai 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 9,
    location: 'Bottrop Zentrum',
    month: 'Mai 2025'
  },
  {
    id: 508,
    date: '2025-05-25',
    displayDate: 'Sonntag, 25. Mai 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 11,
    location: 'Bottrop Zentrum',
    month: 'Mai 2025'
  },
  {
    id: 509,
    date: '2025-05-31',
    displayDate: 'Samstag, 31. Mai 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Mai 2025'
  },
  // Juni 2025
  {
    id: 601,
    date: '2025-06-01',
    displayDate: 'Sonntag, 01. Juni 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Juni 2025'
  },
  {
    id: 602,
    date: '2025-06-07',
    displayDate: 'Samstag, 07. Juni 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Juni 2025'
  },
  {
    id: 603,
    date: '2025-06-08',
    displayDate: 'Sonntag, 08. Juni 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Juni 2025'
  },
  {
    id: 604,
    date: '2025-06-14',
    displayDate: 'Samstag, 14. Juni 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 10,
    location: 'Bottrop Zentrum',
    month: 'Juni 2025'
  },
  {
    id: 605,
    date: '2025-06-15',
    displayDate: 'Sonntag, 15. Juni 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 13,
    location: 'Bottrop Zentrum',
    month: 'Juni 2025'
  },
  {
    id: 606,
    date: '2025-06-21',
    displayDate: 'Samstag, 21. Juni 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Juni 2025'
  },
  {
    id: 607,
    date: '2025-06-22',
    displayDate: 'Sonntag, 22. Juni 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 15,
    location: 'Bottrop Zentrum',
    month: 'Juni 2025'
  },
  {
    id: 608,
    date: '2025-06-28',
    displayDate: 'Samstag, 28. Juni 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 8,
    location: 'Bottrop Zentrum',
    month: 'Juni 2025'
  },
  {
    id: 609,
    date: '2025-06-29',
    displayDate: 'Sonntag, 29. Juni 2025',
    time: '09:00 - 16:30 Uhr',
    course: 'Erste Hilfe Kurs (9 UE)',
    spotsLeft: 12,
    location: 'Bottrop Zentrum',
    month: 'Juni 2025'
  }
];

export const trustBadges = [
  {
    title: 'Anerkannte Ausbildungsstelle',
    icon: 'Award'
  },
  {
    title: 'Praxisnah & verständlich erklärt',
    icon: 'BookOpen'
  },
  {
    title: '1-Tages-Kurs (9 Unterrichtseinheiten)',
    icon: 'Clock'
  },
  {
    title: 'Zentrale Lage in Bottrop',
    icon: 'MapPin'
  }
];

export const contactInfo = {
  name: 'Erste Hilfe Bottrop',
  address: 'Poststraße 6',
  city: '46236 Bottrop',
  phone: '02041-9878666',
  mobile: '0176-80151197',
  email: 'info@erstehilfebottrop.de',
  website: 'www.erstehilfebottrop.de'
};
